import Transfer from '@/pages/Transfer'

export default {
    path: '/transfers',
    component: Transfer,
    children: [
        {
            path: '',
            name: 'transfer',
            component: Transfer,
        },
        {
            path: ':ref',
            name: 'RefTransfer',
            component: Transfer,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/transfer.js